const empowerment = {
    path: '/Empowerment',
    name: 'Empowerment',
    component: () => import('../../views/Empowerment.vue'),
    redirect: '/Empowerment/pledge/houseProperty/rapidValuation',
    meta: {
        title: '渠道-大数据赋能',
        authId: [66],
        function: '大数据赋能'
    },
    children: [
            {
            path: '/Empowerment/pledge/houseProperty/rapidValuation',
            name: '我要估价',
            component: () => import('@/views/pledge/rapidValuation.vue'),
            // redirect: '/Insight/PlaceMarket',
            meta: {
                pageId: 120,
                title: '我要估价',
                fName: '房屋智能估价（单套）',
                authId: [120],
                function: '智能评估｜押品管理'
            }
        },
        {
            path: '/Empowerment/pledge/houseProperty/mapValuation',
            name: '地图估价',
            component: () => import('@/views/pledge/mapValuation.vue'),
            // redirect: '/Insight/PlaceMarket',
            meta: {
                from: '/Empowerment/pledge/houseProperty/rapidValuation',

                pageId: 120,
                title: '地图估价',
                fName: '房屋智能估价（单套）',
                authId: [120],
                function: '智能评估｜押品管理'
            }
        },
        {
            path: '/Empowerment/pledge/houseProperty/resultValuation',
            name: '估价结果',

            component: () => import('@/views/pledge/resultValuation.vue'),
            // redirect: '/Insight/PlaceMarket',
            meta: {
                pageId: 120,

                title: '评估结果',
                fName: '房屋智能估价（单套）',
                authId: [120],
                function: '智能评估｜押品管理'
            }
        },
        {
            path: '/Empowerment/pledge/pledgeManage/taskResult',
            name: '评估结果',
            component: () => import('@/views/pledge/taskResult.vue'),
            meta: {
                // from: '/Empowerment/pledge/pledgeManage/taskRecord',
                title: '批量评估结果',
                pageId: 129,
                authId: [129],
                fName: '房屋智能估价（批量）',

                function: '智能评估｜押品管理'
            }
        },
        {
            path: '/Empowerment/pledge/houseProperty/recordValuation',
            name: '估价记录',
            component: () => import('@/views/pledge/recordValuation.vue'),
            // redirect: '/Insight/PlaceMarket',
            meta: {
                pageId: 121,
                title: '估价记录',
                fName: '房屋智能估价（单套）',
                authId: [121],
                function: '智能评估｜押品管理'
            }
        },
                        {
                    path: '/Empowerment/pledge/pledgeManage/taskDetail',
                    name: 'taskDetail',
                    meta: {
                        from: '/Empowerment/pledge/pledgeManage/taskManageNew',
                        fName: '房屋智能估价（批量）',
                        pageId: 128,
                        authId: [128],
                        function: '智能评估｜押品管理',
                        keepAlive: true
                    },
                    component: () => import('@/views/pledge/taskDetailNew.vue')
                },
        {
            path: '/Empowerment/pledge/pledgeManage',
            name: '押品管理',
            component: () => import('@/views/pledge/pledgeHome.vue'),
            // redirect: '/Empowerment/pledge/pledgeManage/pledgeManage',
            meta: {
                title: '渠道-押品管理',
                authId: [70],
                function: '智能评估｜押品管理'
            },
            children: [
   
                {
                    path: '/Empowerment/pledge/pledgeManage/taskManageNew',
                    name: '我要估价',
                    component: () => import('@/views/pledge/taskManageNew.vue'),
                    meta: {
                        pageId: 128,
                        title: '任务管理（批量）',
                        fName: '房屋智能估价（批量）',
                        authId: [128],
                        function: '智能评估｜押品管理'
                    }
                },
   
                {
                    path: '/Empowerment/pledge/pledgeManage/taskRecord',
                    name: '估价记录',
                    component: () => import('@/views/pledge/taskRecord.vue'),
                    meta: {
                        pageId: 129,
                        title: '估价记录',
                        fName: '房屋智能估价（批 量）',
                        authId: [129],
                        function: '智能评估｜押品管理'
                    }
                },


                {
                    path: '/Empowerment/pledge/pledgeManage/taskDetail',
                    name: '任务详情',
                    meta: {
                        from: '/Empowerment/pledge/pledgeManage/taskManageNew',
                        fName: '房屋智能估价（批量）',
                     pageId: 128,
                        authId: [128],
                        function: '智能评估｜押品管理'
                    },
                    component: () => import('@/views/pledge/taskDetailNew.vue')
                },


  
            ]
        },


    ]
}
export default empowerment;